/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const monologueTokens = {
  ContainerBackgroundColorBaseDefault: '#ebecec',
  ContainerBorderColorBaseDefault: '#ebecec',
  ContainerBorderSizeBaseDefault: '1px',
  ContainerFontSizeBaseDefault: '14px',
  ContainerFontWeightBaseDefault: '400',
  ContainerFontLeadingBaseDefault: '24px',
  ContainerHeightMaximumLargeDefault: '300px',
  ContainerHeightMaximumBaseDefault: '200px',
  ContainerHeightMaximumSmallDefault: '100px',
  ContainerHeightMinimumLargeDefault: '200px',
  ContainerHeightMinimumBaseDefault: '100px',
  ContainerHeightMinimumSmallDefault: '50px',
  ContainerSpacingBody: '16px',
  ScrollbarColorBaseDefault: '#656b6b',
  ScrollbarWidthBaseDefault: '10px',
} as const;
